import DayCalendar from "./DayCalendar.tsx";
import { Box, Grid2, MenuItem, useTheme } from "@mui/material";
import { EScheduleOptions, ScheduleOptionsConfig } from "../../../utils/enums/EBookingListView.tsx";
import { Select } from "theme";
import WeekCalendar from "./WeekCalendar.tsx";
import { FC } from "react";
import useHalls from "../../../api/hooks/useHalls/useHalls.ts";

type BookingScheduleProps = {
  tableLayout: EScheduleOptions;
  setTableLayout: (tableLayout: EScheduleOptions) => void;
  hall: string;
  setHall: (hall: string) => void;
};

const BookingSchedule:FC<BookingScheduleProps> = ({ tableLayout, setTableLayout, hall, setHall }) => {
  const { palette } = useTheme();

  const { halls } = useHalls();

  return (
    <div>
      <Box p={2}>
        <Grid2 container spacing={2} mb={2}>
          <Select
            MenuProps={{
              sx: {
                "& .MuiPaper-root": {
                  background: palette.primary.main,
                },
              },
            }}
            value={tableLayout}
            onChange={(e) => setTableLayout(String(e.target.value) as EScheduleOptions)}
          >
            {ScheduleOptionsConfig.map((el) => {
              return (
                <MenuItem key={el.value} value={el.value}>
                  {el.label}
                </MenuItem>
              );
            })}
          </Select>

          {tableLayout === EScheduleOptions.WEEK && <Select
            MenuProps={{
              sx: {
                "& .MuiPaper-root": {
                  background: palette.primary.main,
                },
              },
            }}
            value={hall}
            onChange={(e) => setHall(String(e.target.value))}
          >
            {halls?.map((el) => {
              return (
                <MenuItem key={el.id} value={el.id}>
                  {el.name}
                </MenuItem>
              );
            })}
          </Select>}
        </Grid2>
        {tableLayout === EScheduleOptions.DAY ? <DayCalendar /> : <WeekCalendar hallId={hall} />}
      </Box>
    </div>
  );
};

export default BookingSchedule;
